// extracted by mini-css-extract-plugin
export default {"wrapper":"uz-z","viewport":"vz-z","container":"wz-z","slide":"xz-z"};